import React from 'react';
import { Moon } from '@lt/components/icons-react';
import styles from './hotelCardDates.module.css';

type HotelCardDatesProps = {
  datesInfo: string;
};

const HotelCardDates: React.FC<HotelCardDatesProps> = ({ datesInfo }) => (
  <div className={styles.dates}>
    {datesInfo}
    <Moon className={styles.moonIcon} />
  </div>
);

export default HotelCardDates;
